'use client';

import { flex } from '@onbeam/business-styled-system/patterns';
import { DesktopNavigation } from './DesktopNavigation';
import { MobileNavigation } from './MobileNavigation';

export const Header = () => (
  <header
    className={flex({
      w: 'full',
      pos: 'relative',
      justify: 'space-between',
      align: 'center',
      maxW: '[90rem]',
      mx: 'auto',
      px: '6',
      py: '5',
      zIndex: 10,
      xl: {
        py: '8',
        px: '10',
      },
    })}
  >
    <DesktopNavigation />
    <MobileNavigation />
  </header>
);
